export default __webpack_public_path__ + "static/media/stats.b9651483.gif";